import React, { useState } from 'react';
import Checkbox from '@mui/material/Checkbox';
import {
	Box,
	Drawer,
	Divider,
	List,
	Button,
	Grid,
	Container,
	FormControlLabel,
} from '@mui/material';
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const TopDrawer = ({
	draw,
	setDraw,
	filterAirlineTBO,
	airlineS,
	handleAirline,
	fareType,
	handleFareType,
	fare,
	stopType,
	handleStopType,
	stop,
}) => {
	const [tab, setTab] = useState('one');
	const [one, setTabOne] = useState(false);
	const [two, setTabTwo] = useState(false);
	const handleChange = (val) => {
		setTab(val);
	};
	return (
		<>
			<Drawer
				anchor={'top'}
				open={draw}
				PaperProps={{
					sx: { width: '100%' },
				}}
				onClose={() => {
					draw ? setDraw(false) : setDraw(true);
					// dispatch(toggleLoginDrawerModal(false));
				}}
				style={{ width: '100%' }}
				// className={styles.drawerlogin}
				onKeyDown
				classes={{
					paper: { width: '100%' },
				}}>
				<Container style={{ padding: 50 }}>
					<Grid container spacing={2}>
						<Grid item xs={3}>
							<Box>
								<span>Stops</span>
							</Box>
							<Box style={{ display: 'flex', flexWrap: 'wrap' }}>
								{stopType &&
									stopType.length > 0 &&
									stopType.map((i, index) => {
										return (
											<FormControlLabel
												control={
													<Checkbox
														checked={stop === i ? true : false}
														onChange={handleStopType}
														name={`${i}`}
														sx={{}}
													/>
												}
												label={
													<>
														<span style={{ fontSize: 12 }}>{i}</span>
													</>
												}
											/>
										);
									})}
							</Box>
						</Grid>
						<Grid item xs={4}>
							<Box>
								<span>Airline</span>
							</Box>
							<Box style={{ display: 'flex', flexWrap: 'wrap' }}>
								{filterAirlineTBO &&
									filterAirlineTBO.length > 0 &&
									filterAirlineTBO.map((i, index) => {
										return (
											<FormControlLabel
												control={
													<Checkbox
														checked={airlineS === i ? true : false}
														onChange={handleAirline}
														name={`${i}`}
														sx={{}}
													/>
												}
												label={
													<>
														<span style={{ fontSize: 12 }}>{i}</span>
													</>
												}
											/>
										);
									})}
							</Box>
						</Grid>
						<Grid item xs={3}>
							<Box>
								<span>Fare Type</span>
							</Box>
							<Box style={{ display: 'flex', flexWrap: 'wrap' }}>
								{fareType &&
									fareType.length > 0 &&
									fareType.map((i, index) => {
										return (
											<FormControlLabel
												control={
													<Checkbox
														checked={fare === i ? true : false}
														onChange={handleFareType}
														name={`${i}`}
														sx={{}}
													/>
												}
												label={
													<>
														<span style={{ fontSize: 12 }}>{i}</span>
													</>
												}
											/>
										);
									})}
							</Box>
						</Grid>
						<Grid item xs={2}>
							<Box
								style={{
									display: 'flex',
									alignItems: 'center',
									cursor: 'pointer',
								}}
								onClick={() => setDraw(false)}>
								Close <i class='fa fa-close' style={{ marginLeft: 5 }}></i>
							</Box>
						</Grid>
					</Grid>
				</Container>
				<Divider />
				<Divider />
			</Drawer>
		</>
	);
};

export default TopDrawer;
